import React from 'react';

// Generic admin table. Optional sorting: pass sortKey/sortDir/onSort and
// mark columns `sortable: true` to render clickable headers (arrow shows
// the active sort). Backwards compatible — screens without onSort get the
// plain headers they had before.
export default function Table({ columns, rows, onRowClick, empty, sortKey, sortDir, onSort }) {
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>
                {onSort && column.sortable ? (
                  <button
                    type="button"
                    className={`sort-button${sortKey === column.key ? ' sort-active' : ''}`}
                    onClick={() => onSort(column.key)}
                  >
                    {column.label}
                    {sortKey === column.key ? (sortDir === 'asc' ? ' ↑' : ' ↓') : ''}
                  </button>
                ) : column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length ? rows.map((row) => (
            <tr onClick={() => onRowClick?.(row)} key={row.id}>
              {columns.map((column) => (
                <td key={column.key}>{column.render ? column.render(row) : row[column.key]}</td>
              ))}
            </tr>
          )) : <tr><td colSpan={columns.length}>{empty}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
